import { useCallback, useEffect, useState } from 'react';
import { adminSubscriptionPurchaseAPI, SubscriptionPurchaseTicketStats } from '../services/api';
import { SUBSCRIPTION_PURCHASE_TICKETS_UPDATED_EVENT } from '../utils/adminSubscriptionPurchaseEvents';

const EMPTY_STATS: SubscriptionPurchaseTicketStats = {
  open_total: 0,
  awaiting_admin: 0,
  awaiting_user: 0,
};

export function useAdminSubscriptionPurchaseTicketCounts(enabled = true) {
  const [stats, setStats] = useState<SubscriptionPurchaseTicketStats>(EMPTY_STATS);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const data = await adminSubscriptionPurchaseAPI.getStats();
      setStats(data);
    } catch {
      setStats(EMPTY_STATS);
    }
  }, [enabled]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    const handler = () => refresh();
    window.addEventListener(SUBSCRIPTION_PURCHASE_TICKETS_UPDATED_EVENT, handler);
    return () => window.removeEventListener(SUBSCRIPTION_PURCHASE_TICKETS_UPDATED_EVENT, handler);
  }, [refresh]);

  return { stats, refresh };
}
